<script setup>
import { useDetectDevice } from '@/composables/device'

defineProps({
  tabs: {
    type: Array,
    required: true,
  },
})
const model = defineModel({ type: String, required: true })

const { isMobile } = useDetectDevice()
</script>

<template>
  <div :class="['column no-wrap', isMobile ? 'page-tabs--mobile' : 'full-height', { 'page-tabs--bottom': isMobile }]">
    <template v-if="tabs.length > 1">
      <q-tabs
        v-model="model"
        class="page-tabs__bar"
        :class="{ 'text-primary': !isMobile }"
        :align="isMobile ? 'justify' : 'left'"
        :no-caps="!isMobile"
        active-color="primary"
        indicator-color="primary"
      >
        <q-tab
          v-for="item in tabs"
          :key="item.name"
          :name="item.name"
          :label="item.label"
        />
      </q-tabs>
      <q-separator class="page-tabs__separator" />
    </template>
    <div v-if="$slots.actions" class="row justify-end q-px-sm">
      <slot name="actions" />
    </div>
    <q-tab-panels
      v-model="model"
      animated
      class="col"
      style="min-height: 0;"
    >
      <slot />
    </q-tab-panels>
  </div>
</template>

<style scoped lang="scss">
.page-tabs--mobile {
  height: calc(100vh - 4rem);
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

.page-tabs__bar {
  flex-shrink: 0;
  width: 100%;
  max-width: 100vw;
}

.page-tabs--bottom {
  .page-tabs__bar {
    order: 2;
  }
  .page-tabs__separator {
    order: 1;
  }
}
</style>
